import {
  Checkbox,
  MessageBar,
  MessageBarType,
  SearchBox,
  Spinner,
  TextField,
  TooltipHost,
} from "@fluentui/react";
import { useEffect, useId, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import ConfigureCard from "../../Components/ConfigureCard/ConfigureCard";
import CustomCommandBar from "../../Components/CustomCommandBar/CustomCommandBar";
import IconButtonItem from "../../Components/IconButtonItem/IconButtonItem";
import Loadable from "../../Components/Loadable/Loadable";
import { AppRoutes } from "../../Constants/AppRoutes";
import { IAlarm } from "../../Models/IAlarm";
import { ISensor } from "../../Models/ISensor";
import { ISentinel, ISentinelRich } from "../../Models/ISentinel";
import { GenericActions } from "../../Redux/Generic/GenericAction";
import { GlobalState } from "../../Redux/RootReducer";
import { IAPIResponse } from "../../Services/AjaxService";
import ApiService from "../../Services/ApiService";
import { GetSensorStates, SetSensorStates, RemoveSensorState } from "../../Utils/SensorCache";
import { ToastMessage } from "../../Utils/UIMessages";
import "./ConfigurationPage.scss";
import NavigationMenu from "../../Components/NavigationMenu/NavigationMenu";

var supportChangeStatusVar: boolean[] = [];
const ConfigurationPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const selectedSentinel: string | null = params.get("sentinelId");
  const [loading, setLoading] = useState<boolean>(false);
  const [reloadCards, setReloadCards] = useState<boolean>(false);
  const [changindSentinelStatus, setChangindSentinelStatus] = useState<
    boolean[]
  >([]);
  const [filterText, setFilterText] = useState<string>("");
  const sentinels: ISentinelRich[] = useSelector(
    (s: GlobalState) => s.generic.sentinels || []
  );

  const [editSentinel, setEditSentinel] = useState<ISentinelRich | null>(null);

  const setChangindSentinelStatusAtIndex = (checkbox: boolean, i: number) => {
    let st: boolean[] =
      supportChangeStatusVar.length === 0
        ? [...changindSentinelStatus]
        : [...supportChangeStatusVar];
    st[i] = checkbox;
    setChangindSentinelStatus(st);
    supportChangeStatusVar = [...st];
  };

  const doReloadCards = () => {
    setReloadCards(true);
    setTimeout(() => {
      setReloadCards(false);
    }, 500);
  };

  useEffect(() => {
    if (selectedSentinel && sentinels.length > 0) {
      trySelectSentinel(selectedSentinel);
    } else {
      setEditSentinel(null);
    }
  }, [selectedSentinel, sentinels]);

  const trySelectSentinel = (targetId: string) => {
    let match: ISentinelRich[] = sentinels.filter(
      (x: ISentinelRich) => x.id.toString() === targetId
    );
    if (match.length > 0) {
      setEditSentinel(match[0]);
    }
  };

  const sensorsEnableAll = async (x_: ISentinelRich) => {
    let x: ISentinelRich = JSON.parse(JSON.stringify(x_));
    let errors: string[] = [];
    let doneSomething: boolean = false;
    for (let i = 0; i < x.sensors.length; i++) {
      let prevState = GetSensorStates(x.sensors[i].id);

      // was on
      if (prevState) {
        let s_ = x.sensors[i];
        doneSomething = true;
        s_.enabled = true;
        let r = await ApiService.SentinelController.UpdateSensor(
          x.id.toString(),
          s_
        );
        if (r.error !== null) {
          errors.push(r.error);
        }
      }
    }

    if (!doneSomething) {
      ToastMessage("warning", "Non sono stati rilevati sensori da riattivare.");
      return;
    }

    if (errors.length === 0) {
      ToastMessage(
        "success",
        "Tutti i sensori sono stati riabilitati secondo l'ultima configurazione presente."
      );
      doReloadCards();
      updateSentinels(x);
    } else {
      errors.forEach((e: string) => {
        ToastMessage("error", e);
      });
    }
  };

  const sensorsDisableAll = async (x_: ISentinelRich) => {
    let x: ISentinelRich = JSON.parse(JSON.stringify(x_));
    let toDisable = x.sensors.filter((y: ISensor) => y.enabled);
    let errors: string[] = [];

    for (let i = 0; i < toDisable.length; i++) {
      let s_ = toDisable[i];
      s_.enabled = false;
      SetSensorStates(s_.id, true); // this was on
      let r = await ApiService.SentinelController.UpdateSensor(
        x.id.toString(),
        s_
      );
      if (r.error !== null) {
        errors.push(r.error);
      }
    }

    if (errors.length === 0) {
      ToastMessage("success", "Tutti i sensori sono stati disabilitati.");
      doReloadCards();
      updateSentinels(x);
    } else {
      errors.forEach((e: string) => {
        ToastMessage("error", e);
      });
    }
  };

  const updateSentinels = (sentinel: ISentinelRich) => {
    let list: ISentinelRich[] = [...sentinels];
    for (let i = 0; i < list.length; i++) {
      if (list[i].id == sentinel.id) {
        list[i] = sentinel;
      }
    }

    dispatch(GenericActions.setSentinels(list) as any);
  };

  const loadSentinels = () => {
    if (sentinels.length === 0) {
      setLoading(true);
    }
    ApiService.SentinelController.GetSentinels((response: IAPIResponse) => {
      if (response.error === null) {
        let results: ISentinelRich[] = response.parsed;
        dispatch(GenericActions.setSentinels(results) as any);

        let st: boolean[] = [];
        results.forEach((x: ISentinelRich) => {
          st.push(false);
        });
        setChangindSentinelStatus(st);
      } else {
        ToastMessage("error", "Impossibile caricare gli allarmi.");
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    loadSentinels();
    supportChangeStatusVar = [];
  }, []);

  const cleanSentinelData = (rawSentinel: ISentinelRich) => {
    let cleaned: ISentinelRich = { ...rawSentinel };
    cleaned.sensors = rawSentinel.sensors.filter(
      (x: ISensor) => !x.logicalDelete
    );
    return cleaned;
  };

  return (
    <div className="fade-in-whole-page">
      <CustomCommandBar
        specials={[
          <div className="command-bar-title">Configurazione Dispositivi</div>,
          <NavigationMenu />,
        ]}
        buttons={[]}
      />
      <div className="sliding-page-content cf-new">
        <Loadable
          isLoading={loading}
          content={
            <div className="configuration-page-card-wrap flex-column-on-small-screen">
              <div className="panel cf-left">
                {/* telefono: il dispositivo si sceglie da un elenco a discesa */}
                <div className="cf-select">
                  <label htmlFor="cf-select">Dispositivo</label>
                  <select
                    id="cf-select"
                    value={editSentinel ? String(editSentinel.id) : ""}
                    onChange={(e) => {
                      if (e.target.value) navigate(AppRoutes.APP_CONFIGURE_PAGE + "?sentinelId=" + e.target.value);
                    }}
                  >
                    <option value="">Scegli</option>
                    {sentinels.map((x: ISentinelRich) => (
                      <option key={x.id} value={x.id}>
                        {x.identifier} · ID {x.id}
                      </option>
                    ))}
                  </select>
                </div>
                <SearchBox
                  placeholder="Cerca"
                  onChange={(e: any, v: string | undefined) => {
                    if (v !== undefined) {
                      setFilterText(v.toLowerCase());
                    }
                  }}
                  onClear={() => {
                    setFilterText("");
                  }}
                />
                <div className="configuration-page-sentinel-list">
                  {sentinels
                    .filter(
                      (x: ISentinelRich) =>
                        x.identifier.toLowerCase().includes(filterText) ||
                        x.id.toString().includes(filterText)
                    )
                    .map((x: ISentinelRich, i: number) => {
                      return (
                        <div
                          className={
                            "configuration-page-card-wrap-row " +
                            (editSentinel && editSentinel.id === x.id
                              ? "configuration-page-card-wrap-row-selected"
                              : "")
                          }
                          key={i}
                        >
                          <div
                            className="configuration-page-card-wrap-row-label-container"
                            onClick={() => {
                              navigate(
                                AppRoutes.APP_CONFIGURE_PAGE +
                                  "?sentinelId=" +
                                  x.id
                              );
                            }}
                          >
                            <div className="configuration-page-card-wrap-row-label">
                              <TooltipHost
                                content={x.identifier}
                                id={"sentinel_id_" + x.id.toString()}
                              >
                                {x.identifier}
                              </TooltipHost>
                            </div>
                            <div className="configuration-page-card-wrap-row-id">
                              ID: {x.id}
                            </div>
                          </div>
                          <div className="configuration-page-card-wrap-row-buttons">
                            <TooltipHost
                              content={"Stato attivazione"}
                              id={"checkbox_sentinel_id_" + x.id.toString()}
                            >
                              {changindSentinelStatus[i] && <Spinner />}
                              {!changindSentinelStatus[i] && (
                                <Checkbox
                                  checked={x.enabled}
                                  onChange={async (
                                    e: any,
                                    checked: boolean | undefined
                                  ) => {
                                    if (checked !== undefined) {
                                      let s: ISentinelRich[] = JSON.parse(
                                        JSON.stringify(sentinels)
                                      );
                                      let target: ISentinelRich | null = null;
                                      for (let i = 0; i < s.length; i++) {
                                        if (s[i].id === x.id) {
                                          s[i].enabled = checked;
                                          target = s[i];
                                        }
                                      }

                                      if (target) {
                                        setChangindSentinelStatusAtIndex(
                                          true,
                                          i
                                        );

                                        // Se stiamo disabilitando il letto, salviamo lo stato dei sensori
                                        if (!checked) {
                                          target.sensors.forEach((sensor: ISensor) => {
                                            if (!sensor.logicalDelete) {
                                              SetSensorStates(sensor.id, sensor.enabled);
                                            }
                                          });
                                        }

                                        ApiService.SentinelController.UpdateSentinel(
                                          target,
                                          async (response: IAPIResponse) => {
                                            if (response.error === null) {
                                              // Se stiamo riabilitando il letto, ripristiniamo lo stato dei sensori
                                              if (checked && target) {
                                                let errors: string[] = [];
                                                let restoredCount = 0;
                                                
                                                for (let sensor of target.sensors) {
                                                  if (!sensor.logicalDelete) {
                                                    let previousState = GetSensorStates(sensor.id);
                                                    
                                                    // Se il sensore era attivo prima della disabilitazione
                                                    if (previousState && !sensor.enabled) {
                                                      sensor.enabled = true;
                                                      let updateResult = await ApiService.SentinelController.UpdateSensor(
                                                        target.id.toString(),
                                                        sensor
                                                      );
                                                      
                                                      if (updateResult.error !== null) {
                                                        errors.push(updateResult.error);
                                                      } else {
                                                        restoredCount++;
                                                      }
                                                    }
                                                    
                                                    // Rimuoviamo lo stato dalla cache
                                                    RemoveSensorState(sensor.id);
                                                  }
                                                }

                                                if (errors.length === 0) {
                                                  if (restoredCount > 0) {
                                                    ToastMessage(
                                                      "success",
                                                      "Letto " +
                                                        x.identifier +
                                                        " abilitato. " +
                                                        restoredCount +
                                                        " sensore/i ripristinato/i."
                                                    );
                                                  } else {
                                                    ToastMessage(
                                                      "success",
                                                      "Letto " +
                                                        x.identifier +
                                                        " abilitato."
                                                    );
                                                  }
                                                } else {
                                                  ToastMessage(
                                                    "warning",
                                                    "Letto " +
                                                      x.identifier +
                                                      " abilitato, ma alcuni sensori non sono stati ripristinati."
                                                  );
                                                  errors.forEach((e: string) => {
                                                    ToastMessage("error", e);
                                                  });
                                                }
                                              } else {
                                                ToastMessage(
                                                  "success",
                                                  "Letto " +
                                                    x.identifier +
                                                    " disabilitato. Lo stato dei sensori è stato salvato."
                                                );
                                              }
                                              
                                              dispatch(
                                                GenericActions.setSentinels(
                                                  s
                                                ) as any
                                              );
                                              
                                              // Ricarichiamo i dati per aggiornare la vista
                                              if (checked) {
                                                loadSentinels();
                                              }
                                            } else {
                                              ToastMessage(
                                                "error",
                                                "Impossibile cambiare lo stato di attivazione del Letto: " +
                                                  x.identifier
                                              );
                                            }
                                            setChangindSentinelStatusAtIndex(
                                              false,
                                              i
                                            );
                                          }
                                        );
                                      }
                                    }
                                    if (editSentinel?.id === x.id) {
                                      doReloadCards();
                                    }
                                  }}
                                />
                              )}
                            </TooltipHost>

                            {x.sensors.filter((x_) => x_.enabled).length ===
                            0 ? (
                              <div>
                                {false && (
                                  <IconButtonItem
                                    iconName="RecurringTask"
                                    tooltip="Ripristina sensori"
                                    onClick={() => {
                                      sensorsEnableAll(x);
                                    }}
                                  />
                                )}
                              </div>
                            ) : (
                              <div>
                                {false && (
                                  <IconButtonItem
                                    iconName="StreamingOff"
                                    tooltip="Disabilita sensori"
                                    onClick={() => {
                                      sensorsDisableAll(x);
                                    }}
                                  />
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}
                </div>
              </div>
              <div className="panel cf-right">
                <Loadable
                  isLoading={reloadCards}
                  content={
                    <div>
                      {!reloadCards && editSentinel && (
                        <ConfigureCard
                          onChange={(sentinel: ISentinelRich) => {
                            let s: ISentinelRich[] = [...sentinels];
                            for (let i = 0; i < s.length; i++) {
                              if (s[i].id === sentinel.id) {
                                s[i] = { ...sentinel };
                              }
                            }
                            dispatch(GenericActions.setSentinels(s) as any);
                          }}
                          sentinel={cleanSentinelData(editSentinel)}
                        />
                      )}
                      {!editSentinel && (
                        <MessageBar messageBarType={MessageBarType.info}>
                          Seleziona una Letto per iniziare a configurarla.
                        </MessageBar>
                      )}
                    </div>
                  }
                />
              </div>
            </div>
          }
        />
      </div>
    </div>
  );
};

export default ConfigurationPage;
